import { render } from "./McCookieBar.vue?vue&type=template&id=ac83143e&scoped=true"
import script from "./McCookieBar.vue?vue&type=script&lang=js"
export * from "./McCookieBar.vue?vue&type=script&lang=js"

import "./McCookieBar.vue?vue&type=style&index=0&id=ac83143e&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac83143e"]])

export default __exports__